<script lang="ts">
    import { getContents } from "../api"
    import { apiBaseURL, baseURL } from "../config"
    import { i18n, location, sprache, pfadstore } from "../store"

    console.log($pfadstore)

    let treffer: {
        breadcrumb: any[]
        seite: Content
        url: string
        blank?: boolean
        teaser: { [key: string]: string }
    }[] = []

    let lade = true

    let suchwort
    $: {
        if (typeof window !== "undefined") {
            const qArr = new URLSearchParams($location.search.replace(/^\?/, ""))
            suchwort = qArr?.get("q")
        }
    }

    async function such(str: string) {
        lade = true
        const s = (((await getContents($sprache, str)) || []) as Content[])
            .map((p) => {
                return {
                    breadcrumb: processBreadcrumb(p.path), // TODO
                    seite: p,
                    url: p.pdfdownload
                        ? apiBaseURL + "/seiten/" + p.id + "/" + p.pdfdownload?.src
                        : p.link
                        ? baseURL + "/" + p.link
                        : p.path,
                    blank: !!(p.pdfdownload || p.link),
                    teaser: Object.assign({}, ...p.rows.map((r) => r.cols)),
                }
            })
            .sort((a, b) => {
                return a.breadcrumb > b.breadcrumb ? 1 : -1
            })

        treffer = s
        lade = false
    }

    function extraProcessing(teaser) {
        if (teaser[0].type == "text") {
            return (
                teaser[0].text
                    .replace(/<[^>]*>?/gm, "")
                    .split(" ")
                    .splice(0, 50)
                    .join(" ") + "..."
            )
        }
    }

    function processBreadcrumb(breadcrumb) {
        const b = breadcrumb.split("/")
        b.shift()

        let crumb = []

        for (let index = 1; index < b.length; index++) {
            let p = "/" + b.slice(0, index + 1).join("/")
            const brcmb = Object.seal($pfadstore[p])
            brcmb?.name && crumb.push(brcmb)
        }
        return crumb
    }

    $: such(suchwort)
</script>

{#if lade}
    Lade...
{:else if treffer?.length}
    <div class="wrapper suchergebnisse">
        <div>
            <p>
                {$i18n("Folgende " + treffer?.length + " Ergebnisse wurden für Ihr Suchwort gefunden")} (<strong
                    >{suchwort}</strong
                >) :<br /><br />
            </p>
        </div>
        <ol class="ergebnisliste">
            {#each treffer as t}
                <li>
                    <a href="{t.url}" target="{t.blank ? '_blank' : null}">{t.seite.title}</a>
                    {#if t.teaser[0].text}
                        <div class="wrapper condensed content">{extraProcessing(t.teaser)}</div>
                    {/if}
                    <div class="breadcrumbs">
                        <ul>
                            <li><a href="/">Startseite</a></li>
                            {#each t.breadcrumb as b}
                                <li><a href="{b.link ? b.link : b.path}" class="bcmb">{b.name}</a></li>
                            {/each}
                        </ul>
                    </div>
                </li>
            {/each}
        </ol>
    </div>
{:else}{$i18n("keine Treffer für")} &nbsp;<b>{suchwort}</b>{/if}
